<script setup>

const props = defineProps({
    time : {
        type: String,
        default: '00:00'
    },
    count: {
        type: Number,
        default: 0
    },
    isFire: {
        type: Boolean,
        default: true
    }
})
</script>
<template>
    <div class="quiz-timer">
        <p class="quiz-timer__text" v-if="props.isFire">
            🔥 {{ props.count }}&thinsp;<svg width='20' height='20'><use href='#leaf'></use></svg>&nbsp;сгорят через:&thinsp;<span>{{ props.time }}</span>
        </p>
        <p class="quiz-timer__text" v-else>
            &nbsp;серия завершится через:&thinsp;<span>{{ props.time }}</span>
        </p>
    </div>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
.quiz-timer {

    &__text {
        display: flex;
        align-items: center;
        font-size: 2rem;
        svg {
            width: 2rem;
            height: 2rem;
            fill: var(--text-accent-2-100);
            stroke: transparent;
        }
        span {
            font-weight: 700;
            color: var(--text-accent-2-100);
        }
    }
}

</style>